module.exports = __webpack_public_path__ + "img/1f370.8363b4c.svg";